export default {
    name: 'courier',
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        async fetchSuppliers(context,payload) {
            payload.localid = generateUUID();
            return await axios.post(`${pay}creditor/burntofi_chrilan/search`,payload)
                .then(({data}) => data)
                .catch((error) => errorHandler.tomcatError(error))
        },
        async updateDispatchDetails(context, payload) {
            const url = `${synergyApi}delivery/updateDispatchDetails`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
        async registration(context, payload) {
            const url = `${synergyApi}courier/registration`;
            return await context.dispatch('sendRequest',{url, payload,})
        },
    }
}
